module.exports = __webpack_public_path__ + "img/Affin Bank.ff9b74a5.png";